(() => {
  let disable = false;
  const elemsToScrollMap = new Map();
  const scrollTimeout = new Map();
  const scrollDebounce = new Map();
  const scrollToSlide = (selector) => {
    const target = document.querySelector(selector);

    if (!target) {
      return;
    }

    const targetX = target.offsetLeft;
    const elemToScroll = target.closest('.carousel__viewport');
    elemToScroll.scrollTo ? elemToScroll.scrollTo(targetX, 0) : elemToScroll.scrollLeft = targetX;
    elemsToScrollMap.set(elemToScroll, targetX);

  };
  const processScroll = (triggeringElemToScroll) => {
    if (disable) {
      return;
    }

    const elemsToScroll = [];

    elemsToScrollMap.forEach((value, key) => {
      elemsToScroll.push(key);
    });

    for (let i = 0; i < elemsToScroll.length; i += 1) {
      const elemToScroll = elemsToScroll[i];
      const oldScrollPosition = elemsToScrollMap.get(elemToScroll);

      if (!elemToScroll) {
        continue;
      }

      if (elemToScroll !== triggeringElemToScroll) {
        continue;
      }

      if (elemToScroll.matches(':hover')) {
        continue;
      }

      const currentScrollPosition = elemToScroll.scrollLeft;

      if (oldScrollPosition !== currentScrollPosition) {
        disable = true;
        return;
      }

      const slides = Array.prototype.slice.call(elemToScroll.querySelectorAll('.carousel__slide'));
      const currentSlideIndex = slides.reduce((acc, slide, index) => {
        if (Math.abs(slide.offsetLeft - currentScrollPosition) < 50) {
          acc = index;
        }

        return acc;
      }, 0);
      const currentSlide = slides[currentSlideIndex];
      const nextTrigger = currentSlide.querySelector('.carousel__next');

      scrollToSlide(nextTrigger.getAttribute('href'));

      return;
    }
  };
  const requestVisibilityCheck = (elem) => new Promise((resolve) => {
    if (!window.IntersectionObserver) {
      resolve(false);
    }

    const options = {
      root: elem.closest('.carousel__viewport'),
      rootMargin: '0px',
      threshold: 0.99
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        resolve(entry.isIntersecting);
      });
      observer.unobserve(elem);
    }, options);
    observer.observe(elem);

  });
  const updateNavigation = (carouselViewportElem) => {
    const slides = Array.prototype.slice.call(carouselViewportElem.querySelectorAll('.carousel__slide'));
    const navigationButtonSelector = 'carousel__navigation-button';
    const navigationButtons = Array.prototype.slice.call(carouselViewportElem.closest('.carousel').querySelectorAll(`.${navigationButtonSelector}`));

    navigationButtons.forEach(elem => elem.classList.remove(`${navigationButtonSelector}--is-current`));

    slides.forEach((slide, index) => {
      requestVisibilityCheck(slide).then((result) => {
        if (!result) {
          return;
        }

        navigationButtons[index].classList.add(`${navigationButtonSelector}--is-current`);
      });
    });
  };

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.carousel a[href^="#carousel"]');

    if (!link) {
      return;
    }

    scrollToSlide(link.getAttribute('href'));
    e.preventDefault();
  });

  document.addEventListener('animationstart', (e) => {
    if (e.animationName.indexOf('carousel') !== 0) {
      return;
    }

    const elemToScroll = e.target.closest('.carousel__viewport');
    const elemPosition = elemToScroll.scrollLeft;
    elemsToScrollMap.set(elemToScroll, elemPosition);
  });

  document.addEventListener('animationiteration', (e) => {
    if (e.animationName.indexOf('carousel') !== 0) {
      return;
    }

    const elemToScroll = e.target.closest('.carousel__viewport');

    window.clearTimeout(scrollTimeout.get(elemToScroll));
    scrollTimeout.set(elemToScroll, window.setTimeout(() => {
      processScroll(elemToScroll);
    }, 100));
  });

  document.addEventListener('scroll', (e) => {
    const elem = e.target;

    if (!elem.matches || !elem.matches('.carousel__viewport')) {
      return;
    }

    window.clearTimeout(scrollDebounce.get(elem));
    scrollDebounce.set(elem, window.setTimeout(() => {
      updateNavigation(elem);
    }, 300));
  }, true);
})();
